export const TASK_DETAILS_INCLUDES = [
  'archivedBy',
  'assignedTo',
  'callType',
  'candidate',
  'createdBy',
  'entity',
  'entityType',
  'jobOrder',
  'outcome',
  'searchProject',
  'sendoutInterview',
  'status',
  'taskType',
  'updatedBy'
];
